import React from 'react';
/* eslint-disable react/jsx-no-target-blank */
function ArtifactViewMainContentCopyright() {
  return (
    <section className="mt col-1-1 pb+ phone--p0">
      <h4 className="pb bo--1 bo-rad--3 color--white bg-color--muted-dark font--16 text--bold color--black-light ph pv- text--">
        Legal
      </h4>
      <div className="grid phone--p0">
        <div className="grid__item">
          <div className="p">
            <p>
              All SourceClear data is copyrighted to SourceClear Inc. and licensed under our{' '}
              <a
                href="https://www.veracode.com/legal-privacy"
                target="_blank"
                className="link--obvious"
              >
                terms of use
              </a>
              . In plain English by using this data in any form you are legally bound to comply with
              these terms of use. Our data is intended to be used by the SourceClear products and
              services only and you are not allowed to copy it or use it outside of our service
              especially with any third party system unless you are a paid customer and using the
              data with the service such as with our Jira integration or our JSON output. You are
              not allowed to automatically scrape or copy data from our site and explicitly not
              allowed to use it for any commercial reasons such as embedding it in other products or
              services of any kind.
            </p>
            <p>
              We invest significant research and development resources into producing data for our
              customers and will use the full extent of the law possible to prosecute violations and
              enforce our terms of use.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
/* eslint-enable react/jsx-no-target-blank */
export default ArtifactViewMainContentCopyright;
